"use client";
import { capitalizeWords } from "@/utils/capitalizeWords";
import { openLoginSosialPopup } from "@/utils/openLoginSosialPopup";
import React from "react";
import { FcGoogle } from "react-icons/fc";
import { FaShareAltSquare, FaFacebook } from "react-icons/fa";

const SocialLoginButton = ({ provider }) => {
  const handleLoginSocial = () => {
    const loginUrl = `${process.env.NEXT_PUBLIC_IMAGE_URL}auth/${provider}`;

    if (window.opener) {
      // Sudah di dalam popup → langsung redirect ke login sosial media
      window.location.href = loginUrl;
    } else {
      // Di tab utama → buka popup login sosial media
      openLoginSosialPopup(loginUrl);
    }
  };
  const getProviderIcon = (provider) => {
    switch (provider) {
      case "google":
        return <FcGoogle size={24} />;
      case "facebook":
        return <FaFacebook size={24} className="bg-white text-blue-600" />;
      // Jika perlu ikon lain, tambahkan case di sini
      default:
        return (
          <FaShareAltSquare size={24} className="text-white bg-slate-700" />
        ); // Jika tidak ada, kembalikan null atau ikon default
    }
  };

  const Icons = getProviderIcon(provider);
  return (
    <a
      href="#"
      onClick={() => handleLoginSocial()}
      className="flex w-full items-center justify-center gap-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:ring-transparent"
    >
      {Icons}
      <span className="text-sm/6 font-semibold">
        {capitalizeWords(provider)}
      </span>
    </a>
  );
};

export default SocialLoginButton;
